<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="병동관리">
            <div class="flex justify-end flex-wrap">
                <vs-chip color="primary">
                    <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(9999)" />
                    <span>+ 병동등록</span>
                </vs-chip>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full">
                    <vs-input class=" w-auto" icon="search" placeholder="검색내용을 입력해주세요." v-model="search" @keyup.enter="wardList" />
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <table style="width:100%;" class="border-collapse calendar">
                        <colgroup>
                            <col width="25%" />
                            <col width="25%" />
                            <col width="25%" />
                            <col width="25%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">병동명</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">담당자</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">직통전화(내선번호)</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">관리</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tr, index) in list" :key="index">
                                <td class="border border-solid d-theme-border-grey-light text-center">{{ tr.MEDICAL_ROOM_NM }}</td>
                                <td class="border border-solid d-theme-border-grey-light text-center">{{ tr.USERNAME }}</td>
                                <td class="border border-solid d-theme-border-grey-light text-center">{{ tr.MEDICAL_ROOM_TEL }}</td>
                                <td class="border border-solid d-theme-border-grey-light text-center" style="padding:10px;">
                                    <vs-row vs-type="flex" vs-justify="center">
                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                            <vx-tooltip text="호실상세설정" position="top">
                                                <vs-button color="success" type="line" icon-pack="feather" icon="icon-book" @click="roomsLink(index)" />
                                            </vx-tooltip>
                                            <vx-tooltip text="병동수정" position="top">
                                                <vs-button color="warning" type="line" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(index)" />
                                            </vx-tooltip>
                                            <vx-tooltip text="병동삭제" position="top">
                                                <vs-button color="danger" type="line" icon-pack="feather" icon="icon-x" @click="removeMedicalRoomConfirm(index)" />
                                            </vx-tooltip>
                                        </vs-col>
                                    </vs-row>

                                    <!-- <vs-chip color="success">
                                        <vs-avatar color="success" icon-pack="feather" icon="icon-book" @click="openPopupFun(index)" />
                                        <span>호실관리</span>
                                    </vs-chip>
                                    <vs-chip color="primary">
                                        <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(index)" />
                                        <span>수정</span>
                                    </vs-chip>
                                    <vs-chip color="danger">
                                        <vs-avatar color="danger" icon-pack="feather" icon="icon-x" @click="removeMedicalRoomConfirm(index)" />
                                        <span>삭제</span>
                                    </vs-chip> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- <vs-table :max-items="cutPage" :data="list" :noDataText="'데이터가 존재하지 않습니다.'">
                <template slot="thead">
                    <vs-th class="table_header" width="20%">병동명</vs-th>
                    <vs-th class="table_header" width="25%">담당자</vs-th>
                    <vs-th class="table_header" width="30%">직통전화(내선번호)</vs-th>
                    <vs-th class="table_header" width="20%">관리</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr v-for="(tr, index) in data" :key="index">
                        <vs-td>{{ tr.MEDICAL_ROOM_NM }}</vs-td>
                        <vs-td>{{ tr.USERNAME }}</vs-td>
                        <vs-td>{{ tr.MEDICAL_ROOM_TEL }}</vs-td>
                        <vs-td>
                            <vs-chip color="success">
                                <vs-avatar color="success" icon-pack="feather" icon="icon-book" @click="openPopupFun(index)" />
                                <span>호실관리</span>
                            </vs-chip>
                            <vs-chip color="primary">
                                <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(index)" />
                                <span>수정</span>
                            </vs-chip>
                            <vs-chip color="danger">
                                <vs-avatar color="danger" icon-pack="feather" icon="icon-x" @click="removeMedicalRoomConfirm(index)" />
                                <span>삭제</span>
                            </vs-chip>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table> -->
            <br />
            <vs-pagination :total="pageCount" v-model="curPage" @input="wardList" :max="7"></vs-pagination>
        </vx-card>
        <vs-popup title="병동 등록 및 수정" :active.sync="openPopup">
            <form>
                <input type="hidden" v-model="roomSeq" />
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="" label="병동명" placeholder="병동명을 입력해주세요." v-model="medicalName" ref="medicalName" />
                        <span class="text-danger text-sm" v-if="flag1">병동명을 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-select autocomplete class="w-full" name="" label="담당자" placeholder="담당자를 선택해주세요." v-model="medicalUser" ref="medicalUser">
                            <vs-select-item :value="''" :text="'담당자를 선택해주세요'" />
                            <vs-select-item :key="index" :value="item.UID" :text="item.USERNAME" v-for="(item, index) in users" />
                        </vs-select>
                        <span class="text-danger text-sm" v-if="flag2">담당자를 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="" label="직통전화" placeholder="직통전화 입력해주세요." v-model="medicalTel" ref="medicalTel" />
                        <span class="text-danger text-sm" v-if="flag3">직통전화 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-textarea class="w-full" name="" label="메모" placeholder="메모 입력해주세요." v-model="medicalMemo" ref="medicalMemo" />
                        <span class="text-danger text-sm" v-if="flag4">메모 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="save">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="openPopup = false">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import store from '../../store/store';
export default {
    data() {
        return {
            search: '',
            curPage: 1,
            cutPage: 7,
            list: [],
            pageCount: 0,
            openPopup: false,
            users: [],
            medicalName: '',
            medicalUser: '',
            medicalTel: '',
            medicalMemo: '',
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: false,
            roomSeq: '',
            loginUid: '',
            level: '',
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        init() {
            //this.wardList();
        },
        async wardList() {
            let sendData = {
                curPage: this.curPage,
                cutPage: this.cutPage,
                search: this.search,
            };
            const { data } = await axiosClass.get('/api/management/wardList', sendData, true);

            // console.log(data);
            if (data.success) {
                this.list = data.list;
                const maxPage = Math.floor(data.list[0].ALL_COUNT / this.cutPage);
                this.pageCount = maxPage < 1 ? 1 : maxPage;
                this.users = data.users;
            }
        },
        async openPopupFun(index = 9999) {
            this.flag1 = false;
            this.flag2 = false;
            this.flag3 = false;
            this.flag4 = false;
            if (index == 9999) {
                this.roomSeq = '0';
                this.medicalName = '';
                this.medicalUser = '';
                this.medicalTel = '';
                this.medicalMemo = '';
            } else {
                const item = this.list[index];
                this.roomSeq = item.MEDICAL_ROOM_SEQ;
                this.medicalName = item.MEDICAL_ROOM_NM;
                this.medicalUser = item.UID;
                this.medicalTel = item.MEDICAL_ROOM_TEL;
                this.medicalMemo = item.MEMO;
            }
            this.openPopup = true;
        },
        //삭제 확인
        removeMedicalRoomConfirm(index) {
            const medicalName = this.list[index].MEDICAL_ROOM_NM;
            this.roomSeq = this.list[index].MEDICAL_ROOM_SEQ;
            let _this = this;
            _this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '해당 병동(' + medicalName + ')를 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: _this.removeMedicalRoom,
            });
        },
        roomsLink(index) {
            // console.log(this.list[index].MEDICAL_ROOM_SEQ);
            location.href = '/management/room/' + this.list[index].MEDICAL_ROOM_SEQ;
        },
        async removeMedicalRoom(index) {
            let sendData = {
                roomSeq: this.roomSeq,
                loginUid: this.loginUid,
            };
            try {
                const { data } = await axiosClass.delete('/api/management/ward', sendData, true);
                if (data.result.MSG == 'ERR_ACCESS') {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'error',
                        text: '접근 권한이 없습니다.',
                        position: 'top-right',
                        iconPack: 'feather',
                    });
                } else if (data.result.MSG == 'OVER_MEDICAL_ROOM_NUMBER') {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'error',
                        text: '해당 병동에 데이터(호실, 스케줄 등)가 존재하여 삭제할 수 없습니다.',
                        position: 'top-right',
                        iconPack: 'feather',
                    });
                } else if (data.result.MSG == 'OK') {
                    this.$vs.notify({
                        color: 'primary',
                        title: '삭제완료',
                        text: '삭제되었습니다.',
                        position: 'top-right',
                        iconPack: 'feather',
                    });
                    this.wardList();
                }
                this.openPopup = false;
            } catch (e) {
                console.log(e);
            }
        },
        //병동 추가 및 수정
        async save() {
            if (this.medicalName.trim() == '') {
                this.flag1 = true;
                return;
            } else if (this.medicalUser == '') {
                this.flag2 = true;
                return;
            }
            let sendData = {
                roomSeq: this.roomSeq,
                medicalName: this.medicalName,
                medicalUser: this.medicalUser,
                medicalTel: this.medicalTel,
                medicalMemo: this.medicalMemo,
            };
            const { data } = await axiosClass.post('/api/management/setWard', sendData, true);
            if (data.success) {
                this.$vs.notify({
                    color: 'primary',
                    title: '저장완료',
                    text: '병동이 저장되었습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                });
                this.wardList();
                this.openPopup = false;
            }
        },
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.level = store.getters.getCDLEVEL;
        this.loginUid = store.getters.getUID;
        this.init();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.vs-button.includeIcon {
    /* float: left; */
}
</style>
